import { connect } from 'react-redux'
import HomeUI from './HomeUI'
import { Dispatch } from 'redux';

import { actionFetchHome } from '../../Actions/ActionCreator';
import HomeState from '../../State/HomeState';
import HomeDispatch from './model';
import ApplicationState from '../../../../ApplicationState';
import IState from '../../../Util/IState';
import IDispatcher from '../../../Util/IDispatcher';

const mapStateToProps = (state: ApplicationState): IState<HomeState> => {
    return {
        state: state.home
    }
}

const mapDispatchToProps = (dispatch: Dispatch): IDispatcher<HomeDispatch> => ({
    dispatcher: {
        fetch: () => { dispatch(actionFetchHome() as any) }
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(HomeUI)